// extracted by mini-css-extract-plugin
var _1 = "VvogFZlstRiwQv7bN3TJ";
var _2 = "xtvYYxKpJJOsk34lM9ts";
var _3 = "ynjcUvzcNoeqJq0q4OLg";
var _4 = "eoJMGmiJvYSQoPamQ0Yn";
export { _1 as "closeButton", _2 as "textPrimary", _3 as "upgradeAccountTitle", _4 as "upgradeActions" }
